import { ProductType } from '~domain/model/core/product-type';
import { LanguageId } from '~domain/model/core/supported-languages';
import { ExternalLinkProps } from '../../ui';

// Define what happens when a policy modification option is selected
export enum ActionType {
  // Open a Typeform
  Typeform = 'typeform',
  // Redirect to an url
  Redirection = 'redirection',
}

// List of all policy modification types
export enum PolicyModificationType {
  Address = 'address',
  AddReplaceRemoveCar = 'addReplaceRemoveCar',
  BankingInformation = 'bankingInformation',
  Cancellation = 'cancellation',
  Claims = 'claims',
  CoInsured = 'coInsured',
  ContactInformation = 'contactInformation',
  Help = 'help',
  OccasionalDrivers = 'occasionalDrivers',
  RequestPolicyCopy = 'requestPolicyCopy',
}

export interface PolicyModificationConfig {
  type: PolicyModificationType;
  actionType: ActionType;
  productTypes?: ProductType[];
  linkOptions?: Pick<ExternalLinkProps, 'openNewTab'> & {
    urlByLang: Record<LanguageId, string>;
  };
  typeformIds?: Record<LanguageId, string>;
}
